const DEFAULT_SELECTORS_EXCLUDED_FROM_CLEANING = [
    '.protected',
    '.vwoFrame',
    '#onetrust-consent-sdk',
    '#onetrust-style',
];

const removeElement = (element: HTMLElement) =>
    element.parentNode && element.parentNode.removeChild(element);

const removeElementsOfNodeList = (elements: NodeList) =>
    Array.prototype.forEach.call(elements, removeElement);

const clean = (
    document: Document,
    selectorsExcludedFromCleaning: string[] = [],
) => {
    const NOT_SELECTORS = DEFAULT_SELECTORS_EXCLUDED_FROM_CLEANING.concat(
        selectorsExcludedFromCleaning,
    )
        .map(s => `:not(${s})`)
        .join('');

    removeElementsOfNodeList(
        document.querySelectorAll(`head > *${NOT_SELECTORS}`),
    );
    removeElementsOfNodeList(
        document.querySelectorAll(`body > *${NOT_SELECTORS}`),
    );
};

export { clean };
